import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import ClickOutside from 'react-onclickoutside';

import map from 'lodash/map';

const propTypes = {
	filter: PropTypes.object,
	onInit: PropTypes.func,
	onChooseItem: PropTypes.func,
	onSuggestItems: PropTypes.func,
	onToggle: PropTypes.func,
	onClear: PropTypes.func,
	intl: PropTypes.func
};

class Single extends React.Component {
	render() {
		const { filter, onInit, onChooseItem, onSuggestItems, onToggle, onClear, intl } = this.props;
		const suggestBtn = ({ filter, onToggle, onClear }) =>
			<div className="filter-suggest-btn">
				<button
					className="clear-btn font-proxima-nova-semibold"
					onClick={() => { onClear(filter.id); }}>
					{intl('Очистить')}
				</button>
				<button
					className="close-btn font-proxima-nova-semibold"
					onClick={() => { onToggle(filter.id); }}
				/>
			</div>;

		return (
			<div className="filter-suggest clearfix">
				{map(filter.suggest, (suggest, i) => {
					const suggestOptions =  suggest.searchData || suggest.data;
					return (
						<div className={cn(
							'filter-suggest__select clearfix', suggest.isOpenSelect && 'is-open')} key={i}>
							<div className="filter-suggest__select-control-wrap">
								<div className="filter-suggest__select-control">
									<input
										type="text"
										value={suggest.suggestQuery}
										placeholder={intl(suggest.placeholder)}
										autoFocus={true}
										onClick={() => onInit(filter.id, suggest.key)}
										onChange={e => {
											onSuggestItems(filter.id, suggest.key, e.target.value);
										}}
									/>

									<div className="filter-suggest__select-suggest">
										<ul>
											{!!suggestOptions && suggestOptions.length
												? suggestOptions.map((item, i) =>
													<li key={i}>
														<a
															href="javascript:;"
															onClick={() => {
																onChooseItem(filter.id, suggest.key, item.id);
															}}
														>
															{ filter.customRender
																? filter.customRender.suggest(item, intl) : intl(item.text) }
														</a>
													</li>
												)
												: <li className="not-found">{intl('Совпадения не найдены')}</li>}
										</ul>
									</div>
								</div>
								<div className="filter-suggest__select-btn">
									{ suggestBtn({ filter, onToggle, onClear }) }
								</div>
							</div>
						</div>
					);
				})}
			</div>
		);
	}

	handleClickOutside() {
		map(this.props.filter.suggest, suggest => {
			if (suggest.isOpenSelect) {
				this.props.onInit(this.props.filter.id, suggest.key);
			}
		});
	}
}

Single.propTypes = propTypes;
export default ClickOutside(Single);


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/filters/suggest/single.js